export default __webpack_public_path__ + "static/media/img-guide-gt-popup-5-se_se@3x.e8fe9e92.png";